<template>
    <div>
        <header-kravicka
                @updateProfil="emitUpdateProfil"
                :profil="profil"
        />

        <main>
            <div class="container">

                <div class="row justify-content-center">

                    <div class="col-md-12 col-lg-8">
                        <h1 class="text-center">Nastav si hru</h1>
                        <!-- TODO text -->
                        <p class="text-center pexesoDescription">Na ktorú obtiažnosť si trúfaš? Dnes len Pohodička, Tak akurát, alebo aj tá najnáročnejšia - Fúúúúha? Vyber si aj obrázok, ktorý máš dnes chuť poskladať a môžeš hrať.</p>
                    </div>

                </div>

                <div class="row align-items-center mb-5">

                    <div class="col-md-12 col-xl-6 text-center text-xl-left mb-3 mb-xl-0">

                        <span class="difficulty --label">Obtiažnosť hry</span>

                        <div class="o-settingsGrid">

                            <template
                                    v-for="obtiaznost in sliderPuzzleObtiaznosti"
                            >
                                <div
                                    class="m-settingsGrid__item"
                                    :class="isSelectedObtiaznost(obtiaznost)"
                                    @click="selectObtiaznost(obtiaznost.id)"
                                >

                                    <div class="a-settingsGrid__image">
                                        <span class="settingsGrid__value">{{ obtiaznost.id }}x{{ obtiaznost.id }}</span>
                                    </div>

                                    <div class="a-settingsGrid__description">
                                        <span class="settingsGrid__name">{{ obtiaznost.slider_puzzle_obtiaznost_nadpis }}</span>
                                        <span class="settingsGrid__about">{{ obtiaznost.slider_puzzle_obtiaznost_popis }}</span>
                                    </div>

                                </div>

                            </template>

                        </div>

                    </div>

                    <div class="col-md-12 col-xl-6 text-center text-xl-left">

                        <span class="difficulty --label">Výber obrázku</span>

                        <div class="o-settingsGrid">

                            <template
                                    v-for="motiv in sliderPuzzleMotivy"
                            >

                                <div
                                    class="m-settingsGrid__item --puzzle"
                                    :class="isSelectedMotiv(motiv)"
                                    @click="selectMotiv(motiv.id)"
                                >

                                    <div class="a-settingsGrid__image">
                                        <img class="img-fluid" :src="motiv.slider_puzzle_motiv_img" alt="">
                                    </div>

                                    <div class="a-settingsGrid__description">
                                        <span class="settingsGrid__name">{{ motiv.slider_puzzle_motiv_nadpis }}</span>
                                    </div>

                                </div>

                            </template>

                        </div>

                    </div>

                </div>

                <div class="row justify-content-center">

                    <div class="col-md-12 text-center mb-5 mb-md-0">

                        <div v-if="setMotiv && setObtiaznost" class="buttonsWrap">
                            <router-link
                                    class="btn --primary --large --startGame"
                                    :to="{ name: 'slider-game', params: { kravicka_id: $route.params.kravicka_id, obtiaznost_id: selectedObtiaznost, motiv_id: selectedMotiv } }"
                            >
                                <span class="icon"></span>Spustiť hru
                            </router-link>
                        </div>

                        <router-link
                                class="endGame d-lg-none d-xl-inline-block"
                                :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }"
                        >
                            Ukončiť hru a vrátiť sa ku kravičke<span class="icon"></span>
                        </router-link>

                    </div>

                </div>

            </div>

        </main>

        <div class="pexesoFooter --right d-none d-md-block">

            <router-link
                    class="btn --secondary --trophy"
                    :to="{ name: 'slider-leaders', params: { kravicka_id: $route.params.kravicka_id } }"
            >
                <span class="icon"></span>Tabuľka najlepších
            </router-link>

            <router-link
                    class="btn --primary closeGame"
                    :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id }}"
            >
                <span class="icon"></span>
            </router-link>

        </div>

    </div>

</template>

<script>
    import EventService from '@/services/EventService.js'
    import HeaderKravicka from "../partials/HeaderKravicka.vue"

    export default {
        components: {HeaderKravicka},
        props: [
            'profil',
        ],
        data() {
            return {
                sliderPuzzleObtiaznosti: [],
                sliderPuzzleMotivy: [],

                selectedObtiaznost: '',
                selectedMotiv: '',
                setObtiaznost: false,
                setMotiv: false,
            }
        },
        mounted() {
            this.toggleBodyClass('addClass', 'pexeso')
            this.toggleBodyClass('addClass', '--settings')

            this.getSliderPuzzleObtiaznosti()
            this.getSliderPuzzleMotivy()
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'pexeso')
            this.toggleBodyClass('removeClass', '--settings')
        },
        computed: {},
        methods: {
            // mounted + destroy
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            getSliderPuzzleObtiaznosti() {
                EventService.getSliderPuzzleObtiaznosti()
                    .then(response => {
                        this.sliderPuzzleObtiaznosti = response.data.data
                        this.selectedObtiaznost = this.sliderPuzzleObtiaznosti[0].id
                        this.setObtiaznost = true
                    })
            },

            getSliderPuzzleMotivy() {
                EventService.getSliderPuzzleMotivy()
                    .then(response => {
                        this.sliderPuzzleMotivy = response.data.data
                        this.selectedMotiv = this.sliderPuzzleMotivy[0].id
                        this.setMotiv = true
                    })
            },

            selectObtiaznost(id) {
                this.selectedObtiaznost = id
            },

            selectMotiv(id) {
                this.selectedMotiv = id
            },

            isSelectedObtiaznost(obtiaznost) {
                return {
                    '--selected' : obtiaznost.id === this.selectedObtiaznost,
                    '--easy' : obtiaznost.pexeso_obtiaznost_img === '--easy',
                    '--medium' : obtiaznost.pexeso_obtiaznost_img === '--medium',
                    '--hard' : obtiaznost.pexeso_obtiaznost_img === '--hard'
                }
            },

            isSelectedMotiv(motiv) {
                return {
                    '--selected' : motiv.id === this.selectedMotiv
                }
            },
        }
    }

</script>